import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Button } from "semantic-ui-react";

import { AdminStore } from "../../stores/admin-store";
import { LoadingSpinner } from "../common/loading-spinner";

interface IAdminViewProps{
	adminStore?: AdminStore;
}

interface IAdminViewState{
}


@inject("adminStore") @observer
export class EmailOptIn extends React.Component<IAdminViewProps, IAdminViewState>{
	constructor(props, state){
		super(props, state);
		this.getOptInEmail = this.getOptInEmail.bind(this);
		}


	async getOptInEmail(){
		let headers = ["username", "firstName", "lastName", "company"];
		await this.props.adminStore.fetchOptInEmail(headers);
		let csv = this.props.adminStore.csvContent;
		let filename = "export.csv";
		let link = document.createElement("a");
		if (link.download !== undefined) { // feature detection
			// Browsers that support HTML5 download attribute
			let url = encodeURI( "data:text/csv;charset=utf-8," + csv);
			link.setAttribute("href", url);
			link.setAttribute("download", filename);
			link.style.visibility = "hidden";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}

	}
	render(){
		return (
			<div>
				<Button className="jibunu-orange" onClick={this.getOptInEmail} content="Get Opt-In Email" />

				{this.props.adminStore.loading &&
					<div>
						<LoadingSpinner text={"fetching Opt-In Email"} />
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/email-opt-in.tsx